// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetInfrastructureForMapRequest,
  TGetInfrastructureForMapModel,
  IMappers,
  TGetInfrastructureForMapResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetInfrastructureForMapResponseSchema } from '../../entities/schemas/V1GetInfrastructureForMapResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetInfrastructureForMapModel(
  parameters: TGetInfrastructureForMapRequest,
): TGetInfrastructureForMapModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'infrastructure-caching',
    pathApi: '/v2/get-infrastructure-for-map/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetInfrastructureForMapOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetInfrastructureForMapRequest;
}

export async function fetchGetInfrastructureForMap<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetInfrastructureForMapOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetInfrastructureForMapResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetInfrastructureForMapModel(parameters),
    config,
  )) as FetchResponse<TGetInfrastructureForMapResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetInfrastructureForMapResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetInfrastructureForMapResponse>;
}
